// @see https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie

export default function setCookie(name, value, options) {
  let cookie = (
    encodeURIComponent(name) + '=' +
    encodeURIComponent(value)
  );

  if (options) {
    if (options.path != null) {
      // Safari does not understand encodeURIComponent()
      cookie += ';path=' + options.path;
    }
    if (options.domain != null) {
      cookie += ';domain=' + options.domain;
    }
    if (options.maxAge != null) {
      cookie += ';max-age=' + options.maxAge;
      cookie += ';expires=' + new Date(Date.now() + options.maxAge).toUTCString();
    }
    if (options.secure) {
      cookie += ';secure';
    }
    if (options.sameSite) {
      cookie += ';sameSite=' + options.sameSite;
    }
  }

  document.cookie = cookie;
}
